export const NAME = 'paperVendors';